$(() => {
    //事業所管理以外はreturn
    if (!$('#corporate-management').length && !$('#facility-management').length) {
        return;
    }

    $('.delete-corporate-but').on('click', function() {
        return confirm('この事業者を削除してもよろしいですか？');
    });

    $('.delete-facility-but').on('click', function() {
        return confirm('この事業所を削除してもよろしいですか？');
    });
    /**
     * アップロード済みワイルの削除
     */
     $('.file-delete').on('click', function(e) {
        e.preventDefault();
        if (!confirm('このファイルを削除してよろしいですか？')) {
            return;
        }
        $this = $(this);
        let dataObj = {};
        dataObj.type = $(this).data('type');
        dataObj.corporate_id = $(this).data('corporate_id');
        let role = $(this).data('role');
        axios.post('/' + role + '/corporate/delete_file', dataObj)
        .then(function (response) {
            alert(response.data.message);
            if (response.data.status) {
                $this.parent().remove();
            }
        });

        return false;
    });
});
